import { ArrowUpRight } from "lucide-react";

export function ArticleFooter({ article }) {
  const originalArticles = Array.isArray(article.original_articles) && article.original_articles.length
    ? article.original_articles
    : [{
        title: article.original_title,
        url: article.original_url,
        source: article.source,
      }];

  return (
    <div className="border-t border-[#E5E5E5] dark:border-zinc-800 pt-6">
      <div className="flex items-center gap-2 mb-2">
        <p className="text-[10px] tracking-[0.2em] uppercase font-mono text-gray-400">
          ORIGINAL ARTIKEL
        </p>
      </div>
      <div className="space-y-3">
        {originalArticles.map((original) => (
          <div key={original.url || `${original.source}-${original.title}`}>
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-2 font-['Archivo'] italic">
              "{original.title || article.original_title}"
            </p>
            <a
              href={original.url || article.original_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-xs font-mono text-gray-500 dark:text-gray-400 hover:text-[#0A0A0A] dark:hover:text-zinc-50 transition-colors underline underline-offset-2 rounded-sm focus:outline-none"
              data-testid="original-article-link"
            >
              L&aelig;s originalen p&aring; {original.source || article.source}
              <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
